import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';

import 'Styles/commonStyles.scss';
import Button from 'Components/CommonComponents/Button/Button';
import EditCandidate from 'Components/Candidate/EditCandidate';

export default function CreateCandidate(props) {
  const navigate = useNavigate();

  return (
    <div className="createCandidate">
      <Button
        type="ghost"
        className="flex items-center mb-4 cursor-pointer font-bold px-0"
        onClick={() => {
          navigate(-1);
        }}
      >
        <BiArrowBack className="dark:text-dark-primaryMain" />{' '}
        <span className="ml-2">Back</span>
      </Button>
      <h1 className="mb-4 text-heading1 text-black dark:text-white">
        Create New Candidate
      </h1>
      <div className="div mt-5 border dark:border-[#3b3b3b] p-spacing3 rounded-md bg-secondaryBgMain dark:bg-dark-secondaryBgMain overflow-y-auto customScrollBar max-h-[calc(90vh-8rem)]">
        <EditCandidate
          manualUpload={true}
          // onClose={()=>onCloseModel()} //TODO: figure out refetching after
        />
      </div>
    </div>
  );
}
